<template>
  <div class="inline-block text-xxs">
      <button class="px-1 py-0" @click="toggleBodyClass('addClass', 'hide-all-help')">Hide All help</button>
      <button class="px-1 py-0" @click="toggleBodyClass('removeClass', 'hide-all-help')">Show All Help</button>
  </div>
</template>

<script>

    export default {

        methods: {
          toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
              el.classList.add(className);
            } else {
              el.classList.remove(className);
            }
          },
        },

    }
</script>